import Cookies from 'js-cookie';
import { Features } from '../../shared/types/ast';

const ABTEST_COOKIE = 'abtest';
const ABTEST_COOKIE_DOMAIN = 'finn.no';

const inThirtyMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);

const defaultCookieConfig = {
    domain: ABTEST_COOKIE_DOMAIN,
    expires: inThirtyMinutes,
};

const currentTime = () => Math.round(Date.now() / 1000);

export function getUserId() {
    const userIdIndex = 2;
    return getDataFromPulseCookie(userIdIndex);
}

export function getAdId() {
    const adIdIndex = 9;
    return getDataFromPulseCookie(adIdIndex);
}

export function getDataFromPulseCookie(i: number) {
    const cookie =
        decodeURIComponent(
            document.cookie.replace(
                new RegExp(
                    `(?:(?:^|.*;)\\s*${encodeURIComponent(
                        '_pulse2data',
                    ).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`,
                ),
                '$1',
            ),
        ) || false;
    if (cookie) {
        return cookie.split(',')[i];
    }
    return;
}

export function getAbTestCookie() {
    const abTestCookie = Cookies.get(ABTEST_COOKIE);
    let activeAbTests = '';

    if (abTestCookie) {
        try {
            activeAbTests = Object.keys(JSON.parse(abTestCookie)).join(',');
        } catch (e) {
            if (window.trackJs) {
                window.trackJs.track(`abtest cookie: ${abTestCookie}`);
            }
        }
    }
    return activeAbTests;
}

export function getSession() {
    return Cookies.get('SESSION');
}

export const getCookiePulseId = () => {
    const pulseData = Cookies.get('_pulse2data');
    return pulseData ? pulseData.split(',')[0] : null;
};

type AbTestFeatureObject = {
    [key: string]: number;
};

const horsehoeAbTestFeatures = (features: Features) =>
    features
        ?.filter((i) => i.abtest)
        .reduce((acc, cur) => {
            acc[cur.id] = currentTime();
            return acc;
        }, {} as AbTestFeatureObject);

const filterExistingAbTests = (
    horseshoeFeatures: Features,
    existingFeatures: string,
) => {
    const existingTests = existingFeatures.split(',');
    return horseshoeFeatures.filter(
        (i) => i.enabled && i.abtest && !existingTests.includes(i.id),
    ) as Features;
};

export function setAbTestCookie(featureSet: Features) {
    //js-cookie will not encode curly braces out of the box so custom encoder is required
    const cookiesWithConverter = Cookies.withConverter({
        write: function (value: AbTestFeatureObject, _name: string) {
            return encodeURIComponent(JSON.stringify(value) as string);
        },
    });

    const abTests = getAbTestCookie();
    // check that current cookie and filter out existing Horseshoe Features
    const filteredFeatures = filterExistingAbTests(featureSet, abTests);
    // create abTest cookie entries for features in this repo
    const values = horsehoeAbTestFeatures(filteredFeatures);
    if (filteredFeatures.length > 0) {
        if (abTests) {
            try {
                // if the cookie exists, then re-write it augmented with new entries from horseshoe features
                const originalCookie = decodeURIComponent(
                    Cookies.get(ABTEST_COOKIE) as string,
                );
                const originalCookieAsJSON = JSON.parse(originalCookie);
                const augementedCookie = { ...originalCookieAsJSON, ...values };
                // delete the original cookie
                Cookies.remove(ABTEST_COOKIE);
                //create a new cookie
                cookiesWithConverter.set(
                    ABTEST_COOKIE,
                    augementedCookie,
                    defaultCookieConfig,
                );
            } catch (e) {
                console.error(
                    `Error while parsing existing abtest cookie ${e}`,
                );
            }
        } else {
            cookiesWithConverter.set(
                ABTEST_COOKIE,
                values,
                defaultCookieConfig,
            );
        }
    }
}
